import React, { useState } from "react";

import GreenButton from "../cinema-draft-button/cinema-draft-button.component";
import { TextField } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Card } from "./style";
import exchange from "../../public/Exchange - Icon.svg";
import arrow from "../../public/Button - Icon.svg";
import arrow2 from "../../public/Button - Icon (2).svg";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import FormHelperText from "@material-ui/core/FormHelperText";
const CssTextField = withStyles({
  root: {
    "& .MuiInput-underline:after": {
      borderBottomColor: "#009EE4",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #009EE4",
        borderRadius: "80px",
      },
      "&:hover fieldset": {
        borderColor: "#009EE4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009EE4",
      },
    },
  },
})(TextField);
const ConnectionModal = ({ openModal, connection_issue,setConnectModal }) => {
  const [bal, setbal] = useState(true);
  const [slug, setslug] = useState("");
  const [isavailable, setavail] = useState(true);

  const handleChange = e => {
    const { name, value } = e.target;
    setslug(value);
  };
  return (
    <Card>
      <div className={`modal ${openModal ? "is-active" : ""}`}>
        <div className="modal-background"></div>
        <div className="modal-content">
          <div className="upperdiv">
          <CloseIcon
              onClick={() => setConnectModal(false)}
              style={{ cursor: "pointer", color: "#009EE4" }}
            />
          </div>

          <div className="middiv l">
            <img src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1610798729/cd3d/Group_5262_1_wbfdez.png"></img>
            <p className="warn">Welcome to the Jungle! </p>
            <p className="inf">
              {connection_issue == 1
                ? "Contract is not deployed on this network. Please change your network to "
                : "Please connect your TronLink or other compatible web wallet below."}
              {connection_issue == 1  && <b>Mainnet.</b>}
              
            </p>
            {connection_issue == 1 && <p>Don't know how? <a href = "https://www.youtube.com/watch?v=hFHVfFLSZo4" target="_blank">{` Click here`}</a></p>}

            {connection_issue == 0 && <p>Haven't installed TronLink yet? <a href = "https://www.tronlink.org/" target="_blank">{` Click here`}</a></p>}
            {/* {connection_issue == 1 && <p><a href = "http://trongrid.io/faucet" target="_blank">Add testnet TRX</a> to your wallet</p>} */}
            {/* <GreenButton style={{ background: "#691AAA", color: "#ffffff" }}>
              Connect Now
            </GreenButton> */}
          </div>
          <div className="middiv s">
            <img src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1610798729/cd3d/Group_5262_1_wbfdez.png"></img>
            <p className="warn">Mobile User? </p>
            <p className="inf">
              {connection_issue == 1
                ? "Contract is not deployed on this network. Please change your network to "
                : "Use your TronLink DApp Browser:"}
              {connection_issue == 1  && <b>Mainnet.</b>}
              
            </p>

            {connection_issue == 0 && <p className="txt1"> {"Open app > “My” tab > Advanced Features > DApp Browser >"}</p>}
            {connection_issue == 0 && <a href = "https://crystalelephant.net" target="_blank">{`https://crystalelephant.net`}</a>}
            
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ConnectionModal;
